import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import StatusBadge from '../shared/StatusBadge';
import { Calendar, ChevronDown, ChevronRight, Clock } from 'lucide-react';
import { convertTo12HourIfNeeded } from '../../services/TimeFormat24hr';

const EnquiryDetailModal = ({ isOpen, onClose, enquiry }) => {
    const [showFollowUps, setShowFollowUps] = useState(false);

    useEffect(() => {
        if (isOpen) {
        }
    }, [isOpen]);



    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Enquiry - ${enquiry?.user_name} `}>
            <div className="">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6">

                    <div>
                        <p className="text-sm text-gray-500 font-medium ">Name</p>
                        <p className="text-gray-800 font-semibold mt-1 capitalize">{enquiry?.user_name || "-"}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500 font-medium">Contact</p>
                        <p className="text-gray-800 font-semibold mt-1">{enquiry?.phone || "-"}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500 font-medium">Email</p>
                        <p className="text-gray-800 font-semibold mt-1">{enquiry?.email || "-"}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500 font-medium">Source</p>
                        <p className="text-gray-800 font-semibold mt-1">{enquiry?.source || "-"}</p>
                    </div>

                    <div >
                        <p className="text-sm text-gray-500 font-medium">Remarks</p>
                        <p className="text-gray-800 mt-1">{enquiry?.remarks || "-"}</p>
                    </div>

                    <div >
                        <p className="text-sm text-gray-500 font-medium">Status</p>
                        <StatusBadge status={enquiry?.status} />
                    </div>

                </div>
            </div>
            <div className='mt-5'>
                <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setShowFollowUps(!showFollowUps)}
                >
                    <label className="block text-sm font-medium text-gray-700">
                        Follow-Ups 
                    </label>

                    {showFollowUps ? (
                        <ChevronDown size={20} />
                    ) : (
                        <ChevronRight size={20} />
                    )}
                </div>
                <div className="max-h-[300px] overflow-y-auto">
                    {showFollowUps && (<>
                        {(enquiry?.followups ?? []).length == 0 && <div className='text-center py-3 bg-gray-50'>No follow-up records found.</div>}
                        {(enquiry?.followups ?? []).map((followup, index) => {                            
                            const followUpTime = convertTo12HourIfNeeded(followup?.time ?? '');
                            return (
                                <div key={index} className="flex items-start gap-4 p-3 bg-gray-50 rounded-lg">
                                    <div className={`p-2 bg-white rounded-full border `}>
                                        <Clock size={20} />
                                    </div>
                                    <div className="flex-1">
                                        <div className="flex justify-between items-center">
                                            <p className="font-semibold text-gray-800">{followUpTime}</p>
                                            <p className={`text-sm font-medium `}>{followup?.method}</p>
                                        </div>
                                        <div className="text-sm text-gray-500 mt-1 flex items-center gap-2">
                                            <Calendar size={14} />
                                            <span>{new Date(followup?.date).toLocaleDateString()}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>)}
                </div>
            </div>
        </Modal>
    );
};

export default EnquiryDetailModal;
